import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './CarSlideshow.css';
import { useNavigate } from 'react-router-dom';

const Slideshow = ({ excludeCarId }) => {
  const navigate = useNavigate();
  const [carList, setCarList] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const handleCarClick = (car) => {
    navigate(`/Inventory/${car._id}`, { state: { car } });
  };
  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await axios.get('https://zoomautos.co.uk/api/cars'); // Adjust API URL if needed
        const allCars = response.data;
        // Exclude the car with the specified car_id
        console.log(excludeCarId);
        const filteredCars = allCars.filter(car => car.list === "yes" && car._id !== excludeCarId);
        setCarList(filteredCars);
      } catch (error) {
        console.error('Error fetching car details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCars();
  }, [excludeCarId]);
  const settings = {
    infinite: carList.length > 3, // Disable infinite scrolling if cars are less than 3
    speed: 1000, // Speed of transition (in milliseconds)
    slidesToShow: Math.min(3, carList.length), // Show only the available number of cars if less than 3
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2500, // Delay between auto slides (in milliseconds)
    arrows: true, // Enable next/previous arrows
    dots:false,
    responsive: [
      {
        breakpoint: 1024, // When the screen width is less than 1024px
        settings: {
          slidesToShow: Math.min(1, carList.length), // Adjust based on carList length
          slidesToScroll: 1,
          infinite: carList.length > 1, // Disable infinite loop for 1 car
          dots:false,
        },
      },
      {
        breakpoint: 600, // When the screen width is less than 600px
        settings: {
          slidesToShow: Math.min(1, carList.length), // Adjust based on carList length
          slidesToScroll: 1,
          infinite: carList.length > 1, // Disable infinite loop for 1 car
          dots:false,
        },
      },
    ],
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="row-container">
      {/* Card showing total number of cars */}
      <div className="total-cars-card">
  {excludeCarId == null ? (
    <>
      <h2>Total Cars</h2>
      <p>{carList.length }</p>
    </>
  ) : (
    <>
      <h2>Other Cars</h2>
      <p>{carList.length}</p>
    </>
  )}
</div>
      {/* Horizontal Slideshow */}
      <div className="carslideshow-container">
        <Slider {...settings}>
          {carList.map((car) => (
            <div key={car.id} className="carslide" onClick={() => handleCarClick(car)}>
              <img src={car.imagess[0]} alt={`${car.make} ${car.year}`} className="car-image" />
              <div className="car-overlay">
                <div className="car-info">
                  <span className="car-make">{car.manufacturer}</span>
                  <span className="car-year">{car.year}</span>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Slideshow;
